import './css/FlexCanvas.css';
import './css/PhotoPuzzle.css';
import './css/PhotoPuzzleDialog.css';
import PhotoPuzzle from "./PhotoPuzzle.mjs";

let icons = {
	"close":'<svg viewBox="0 0 48 48" fill="none"><path d="M30.4445 24L40.1104 14.3341C41.2965 13.148 41.2965 11.2249 40.1104 10.0378L37.9622 7.8896C36.7761 6.70347 34.853 6.70347 33.6659 7.8896L24 17.5555L14.3341 7.8896C13.148 6.70347 11.2249 6.70347 10.0378 7.8896L7.8896 10.0378C6.70347 11.2239 6.70347 13.147 7.8896 14.3341L17.5555 24L7.8896 33.6659C6.70347 34.852 6.70347 36.7751 7.8896 37.9622L10.0378 40.1104C11.2239 41.2965 13.148 41.2965 14.3341 40.1104L24 30.4445L33.6659 40.1104C34.852 41.2965 36.7761 41.2965 37.9622 40.1104L40.1104 37.9622C41.2965 36.7761 41.2965 34.853 40.1104 33.6659L30.4445 24Z" fill="var(--icon-color)"/></svg>',
}

let dialogs = new Array();

let wrapper_on_click = function(evt) {
	let el = evt.target;

	if (el === this.wrapper) {
		// history.back();
	} else {
		let action = el.dataset['action'];

		if (action) {
			evt.preventDefault();
			
			if (['close','cancel'].includes(action)) {
				history.back();
			}

			let cb = this.handlers[action];

			if (cb) {
				(cb.bind(this))(action, this.get_data());
			}
		}
	}
}

let get_default = function(x, y) {
	if ((x === undefined) || (x === null) || (x === 0)) {
		return y;
	}

	return x;
}

window.addEventListener("popstate", evt => {
	if (dialogs.length > 0) {
		let dlg = dialogs.pop();

		dlg.do_close();
		evt.preventDefault();
	}
})

document.addEventListener('keydown', evt => {
	let key = evt.key;

	if (key === 'Escape') {
		if (dialogs.length > 0) {
			history.back();
		}
	}
})

class PhotoPuzzleDialog {
	constructor(image_url) {
		let settings = {
			width: 456,
			animation: 'fade'
		}

		let el = document.createElement('dialog');

		el.setAttribute('id', 'photo-puzzle-dialog');
		el.classList.add('photo-puzzle-dialog');
		el.innerHTML = '<div class="dialog-content"><div data-id="photo-puzzle" /></div>';
		document.body.append(el);

		this.photo_puzzle = PhotoPuzzle(el.querySelector('[data-id="photo-puzzle"]'), image_url);

		this.photo_puzzle.on('countdown-start', () => {
			if (this.handlers['countdown-start'] && (typeof this.handlers['countdown-start'] === 'function')) {
				this.handlers['countdown-start']();
			}
		})

		this.photo_puzzle.on('countdown-end', () => {
			if (this.handlers['countdown-end'] && (typeof this.handlers['countdown-end'] === 'function')) {
				this.handlers['countdown-end']();
			}
		})

		this.photo_puzzle.on('start', () => {
			if (this.handlers['start'] && (typeof this.handlers['start'] === 'function')) {
				this.handlers['start']();
			}
		})

		this.photo_puzzle.on('win', (data) => {
			if (this.handlers['win'] && (typeof this.handlers['win'] === 'function')) {
				this.handlers['win'](data);
			}
		})

		this.el = el;
		this.el.dialog = this;
		this.width = settings.width;
		this.animation = settings.animation;
		this.dialogs = dialogs;	
		this.handlers = {};	

		let a = document.createElement('a');

		if (!this.el.transformed === true) {
			a.setAttribute('href', '#');
			a.setAttribute('data-action', 'close');
			a.setAttribute('class', 'ux-close-icon');
			a.innerHTML = icons['close'];

			this.el.querySelector('.dialog-content').append(a);
			this.el.style.setProperty('--width', this.width + 'px');
			this.el.transformed = true;
		}

		this.wrapper = document.createElement('div');
		this.wrapper.classList.add('photo-puzzle-dialog-backdrop');
		this.el.parentNode.insertBefore(this.wrapper, this.el);
		this.wrapper.appendChild(this.el);
		this.wrapper.addEventListener('click', wrapper_on_click.bind(this));
	}

	open() {
		this.el.data = null;
		this.el.classList.add('open');
		this.el.classList.remove('sf-animate-' + this.animation + '-out');
		this.el.classList.add('sf-animate-' + this.animation + '-in');

		history.pushState({id: get_default(this.el.id,''), type:'photo-puzzle-dialog'},'', '#' + get_default(this.el.id, ''));	
		dialogs.push(this);

		this.photo_puzzle.start();
	}

	close() {
		history.back();
	}

	do_close() {
		this.el.classList.remove('sf-animate-' + this.animation + '-in');
		this.el.classList.add('sf-animate-' + this.animation + '-out');

		setTimeout(() => {
			this.el.classList.remove('open');
			this.el.closest('.photo-puzzle-dialog-backdrop').remove();
		}, 500)
	}

	set_data(data) {
		this.el.data = data;
	}

	get_data() {
		return this.el.data;
	}

	on(action, cb) {
		let v_action = action.trim().toLowerCase();

		if ((typeof v_action === 'string') && (typeof cb === 'function')) {
			this.handlers[v_action] = cb;
		}
	}

	trigger(action) {
		if (['close','cancel'].includes(action)) {
			history.back();
		}

		let cb = this.handlers[action];

		if (cb) {
			(cb.bind(this))(action, this.get_data());
		}			
	}
}

export default (image_url) => {
	return new PhotoPuzzleDialog(image_url);
}